import { createFileRoute } from "@tanstack/react-router"
import CollectionDemandTab from "~/components/collections/tabs/CollectionDemandTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/demand-planning/fashion/$collectionId/_layout/demand")(
  {
    component: RouteComponent,
  },
)
function RouteComponent() {
  usePageTracking("Collection - Demand")

  return <CollectionDemandTab />
}
